/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DocumentType {
    ALL = 'All',
    TAX = 'Tax',
    STATEMENT = 'Statement',
}
